// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tbl_col th[data-v-0e5507f0] {\n  text-align: center;\n}\n.desc_list ul li[data-v-0e5507f0] {\n  text-align: left;\n}\n.cas_area[data-v-0e5507f0]:not(:first-child) {\n  margin-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
